<button (click)="click($event)"
        [permission-lock]="permissions"
        [disabled]="!preconditions"
        type="button"
        mat-menu-item>
  <ng-content></ng-content>
</button>
